<span title="{{ title | blah }}">
    <mat-icon *ngIf="schedulingStatus == 'UnknownStatus'"
        style="vertical-align: middle; width: 8px"
        [style.font-size.px]="size"
        [style.color]="color">radio_button_unchecked</mat-icon>
    <mat-icon *ngIf="schedulingStatus == 'Delayed'"
        style="vertical-align: middle;"
        [style.font-size.px]="size"
        [style.color]="color">warning</mat-icon>
    <mat-icon *ngIf="schedulingStatus == 'OnSchedule'"
        style="vertical-align: middle;"
        [style.font-size.px]="size"
        [style.color]="color">access_time</mat-icon>
    <mat-icon *ngIf="schedulingStatus == 'FinishedWithDeviations' || schedulingStatus == 'AcceptedDelayed'"
        style="vertical-align: middle;"
        [style.font-size.px]="size"
        [style.color]="color">check_circle_outline</mat-icon>
    <mat-icon *ngIf="schedulingStatus == 'WithDeviations'"
        style="vertical-align: middle;"
        [style.font-size.px]="size"
        [style.color]="color">access_time</mat-icon>
    <mat-icon *ngIf="schedulingStatus == 'FinishedOnSchedule' || schedulingStatus == 'AcceptedOnSchedule'"
        style="vertical-align: middle;"
        [style.font-size.px]="size"
        [style.color]="color">check_circle</mat-icon>
</span>